/**
 * icaFlyerContent — copy for the standalone /icaflyer marketing flyer.
 *
 * This flyer replaces an outdated printed/embedded flyer that ICA hosts on
 * their own website. The previous version described a now-removed ACH /
 * bank-account-linking payment flow; that section has been intentionally
 * dropped here. Entry fees are now paid by card at online checkout and
 * winnings are paid out by direct deposit.
 *
 * Edit copy here — IcaFlyerPage.tsx only handles layout/presentation.
 */

export const icaFlyerContent = {
  brand: {
    wordmark: 'HighCall Rodeo',
    url: 'highcallrodeo.com',
    badge: 'New app, new look',
  },

  hero: {
    headline: "We've Gone Paperless",
    subhead:
      'Enter rodeos, pay your fees, follow the draw, and get paid — all from your computer or phone at highcallrodeo.com.',
  },

  /**
   * The two numbered setup steps. The one-email-per-profile rule carries
   * over verbatim from the old flyer because the app still enforces it.
   * Step 2 deliberately omits the old ACH / bank-account instructions.
   */
  steps: [
    {
      number: '1',
      title: 'Create Your Profile',
      body:
        "Go to highcallrodeo.com and set up your profile. Every roper needs their own email address — one email cannot be linked to two profiles.",
    },
    {
      number: '2',
      title: 'Enter & Pay Online',
      body:
        'Register for any rodeo right in the app and pay your entry fees securely by card at checkout — no paperwork and no cash at the table.',
    },
  ],

  /** The Draw / Re-Entries / Trades workflow blocks from the old flyer. */
  inApp: {
    eyebrow: 'It All Happens In The App',
    items: [
      {
        title: 'Draw',
        body:
          'When entries close, the draw is generated and posted in the app. Check your run order and performance from anywhere.',
      },
      {
        title: 'Re-Entries',
        body:
          'Re-entries to fill the performances run the Friday entries close, 7:00–9:00 PM. They must be paid at the time of entry, and an extra $50 is added to the entry fee through HighCall.',
      },
      {
        title: 'Trades',
        body:
          'Request and confirm your trades in the app. All trades must be completed before 10:00 AM on Saturday.',
      },
    ],
  },

  /** Hard deadlines — kept faithful to the schedule on the old flyer. */
  deadlines: [
    { label: 'Entries close', value: 'Monday at 7:00 PM' },
    {
      label: 'Entry fees due',
      value: 'Wednesday at 7:00 PM, before the first performance',
      emphasis: 'No exceptions',
    },
    { label: 'Draw posted', value: 'Wednesday by 10:00 AM' },
  ],

  contacts: [
    { label: 'ICA office', value: '(208) 899-0498' },
    { label: 'HighCall support', value: '(208) 918-1591' },
  ],

  footer: 'Get started today at highcallrodeo.com',
} as const;

export type IcaFlyerContent = typeof icaFlyerContent;
